<script lang="ts">
    import ActionBarButton from "../ActionBarButton.svelte";
    import EmojiIcon from "../../Icons/meta/EmojiIcon.svelte";
    import EmojiSubMenu from "../EmojiSubMenu.svelte";
    import { activeSecondaryZoneActionBarStore, openedMenuStore } from "../../../Stores/MenuStore";
    import LL from "../../../../i18n/i18n-svelte";
    import { createFloatingUiActions } from "../../../Utils/svelte-floatingui";

    function toggleEmojiPicker() {
        if ($activeSecondaryZoneActionBarStore === "emote") {
            activeSecondaryZoneActionBarStore.set(undefined);
        } else {
            activeSecondaryZoneActionBarStore.set("emote");
            openedMenuStore.closeAll();
        }
    }

    const [floatingUiRef, floatingUiContent] = createFloatingUiActions(
        {
            placement: "bottom-start",
            //strategy: 'fixed',
        },
        8,
    );
</script>

<!--     media="./static/Videos/Smileys.mp4" -->
<ActionBarButton
    onclick={() => {
        toggleEmojiPicker();
    }}
    classList="group/btn-emoji"
    tooltipTitle={$LL.actionbar.help.emoji.title()}
    state={$activeSecondaryZoneActionBarStore === "emote" ? "active" : "normal"}
    dataTestId="emoji-btn"
    action={floatingUiRef}
    desc={$LL.actionbar.help.emoji.desc()}
    bottomTooltip
    ariaLabel="Эмодзи"
>
    <EmojiIcon />
</ActionBarButton>
{#if $activeSecondaryZoneActionBarStore === "emote"}
    <div use:floatingUiContent class="absolute">
        <EmojiSubMenu />
    </div>
{/if}
